/* eslint-disable @typescript-eslint/no-duplicate-type-constituents */

import type { StaticMeta } from './century-objects.js';

export const NumericOp = ['=', '<>', '>', '>=', '<', '<='] as const;

export const DateTimeOp = NumericOp;
export const StringOp = ['=', '<>', '>', '>=', '<', '<=', '~', '!~'] as const;

export const BooleanOp = ['is null', 'is not null'] as const;

export type NumericOpType = (typeof NumericOp)[number];
export type DateTimeOpType = (typeof DateTimeOp)[number];
export type StringOpType = (typeof StringOp)[number];
export type BooleanOpType = (typeof BooleanOp)[number];

export const NumericFields = ['volume', 'documentId', 'documentPartId'] as const;
export type SimpleNumericFields = (typeof NumericFields)[number];
export const DateTimeFields = ['creationTime'] as const;
export type SimpleDateTimeFields = (typeof DateTimeFields)[number];
export const StringFields = ['sequenceUid', 'source'] as const;
export type SimpleStringFields = (typeof StringFields)[number];
export type SimpleFields = SimpleNumericFields | SimpleDateTimeFields | SimpleStringFields;
export type AnyOpType = NumericOpType | DateTimeOpType | StringOpType;
export type SimpleBooleanFields = 'haveWarning';

export type SimpleFilter =
    | [SimpleNumericFields, NumericOpType, number | string]
    | [SimpleDateTimeFields, DateTimeOpType, string]
    | [SimpleStringFields, StringOpType, string]
    | [SimpleBooleanFields, BooleanOpType];

export type GroupOpType = 'and' | 'or';

export type StaticMetaFilter = [{ staticMeta: keyof StaticMeta; caseSensitive?: boolean }, AnyOpType, number | string];
export type StaticMetaRowsFilter = [{ staticMetaRows: { staticMeta: keyof StaticMeta; caseSensitive?: boolean; value: number | string }[]}];

export type SchemaRefObj = {
    group: string | null;
    owner: string;
    profile: string;
    schema: string;
};
export type SchemaFieldRefObj = SchemaRefObj & {
    field: string;
};
export type SchemaRef = [SchemaRefObj['group'], SchemaRefObj['owner'], SchemaRefObj['profile'], SchemaRefObj['schema']];
export type SchemaFieldRef = [...SchemaRef, SchemaFieldRefObj['field']];
export type SchemaFilter = [{ meta: SchemaRef; use?: SchemaUsageType }];
export type SchemaUsageType = 'pdv' | 'document';
export type SchemaFieldFilter = [{ meta: SchemaFieldRef; use?: SchemaUsageType }, AnyOpType, number | string];

export type SingleFilter = Readonly<SimpleFilter | StaticMetaFilter | StaticMetaRowsFilter | SchemaFilter | SchemaFieldFilter>;

export type CenturyFilterObject = Partial<Record<GroupOpType, AnyCondition[]>>;

export type CenturyFilterArray = AnyCondition[];

export type CenturyFilterSimpleArray = [GroupOpType, ...AnyCondition[]];

export type AnyCondition = SingleFilter | CenturyFilterObject | CenturyFilterArray | CenturyFilterSimpleArray;

export type CenturyFilter = CenturyFilterObject | CenturyFilterArray | CenturyFilterSimpleArray;

export const SimpleSortFileds = ['volume', 'sequenceUid', 'documentId', 'documentPartId', 'creationTime'] as const;
export type SimpleSortFiledsType = (typeof SimpleSortFileds)[number];
export type OrderType = 'asc' | 'desc';

export type SimpleSort = { field: SimpleSortFiledsType; order?: OrderType };
export type SchemaFieldSort = { meta: SchemaFieldRef; order?: OrderType; use?: SchemaUsageType };
export type CenturySortSingle = SimpleSort | SchemaFieldSort;
export type CenturySort = CenturySortSingle | CenturySortSingle[];

export type FilterIdArray = (string | number)[];

export type QueryDocumentListFilterSimple = {
    volumeIdList?: FilterIdArray | null | undefined;
    profile?: string | null | undefined;
    referent?: string | null | undefined;
};
